import { h } from "preact";
import { copyIcon } from "../../../assets";
import styles from "./promoBannerCoupon.module.css";

function PromoBannerCoupon({ coupon, copied, onCopy }) {
    return (
        <div className={styles.couponWrapper}>
            <span className={styles.couponLabel}>Use o cupom</span>

            <div className={styles.couponBox}>
                <span className={styles.couponText}>{coupon}</span>

                <button
                    type="button"
                    onClick={onCopy}
                    className={styles.copyButton}
                    style={{ "--copy-icon": `url(${copyIcon})` }}
                    aria-label="Copiar cupom"
                >
                    {copied && (
                        <span className={styles.copyTooltip}>Copiado</span>
                    )}
                </button>
            </div>
        </div>
    );
}

export default PromoBannerCoupon;
